import { Reducer } from 'redux';

import {
    KnownAction,
    MultiTenantActions,
} from './Actions';

import {
    EmailTenantsResult,
} from '../../Models/Api/strongbox.financialportal';

export interface IMultiTenantState {
    availableTenants?: EmailTenantsResult;
}

const defaultState: IMultiTenantState = {
    availableTenants: undefined,
}

export const reducer: Reducer<IMultiTenantState, KnownAction> = (state: IMultiTenantState | undefined, action: KnownAction): IMultiTenantState => {
    let newState: IMultiTenantState | undefined = undefined;

    switch (action.type) {
        case MultiTenantActions.MultiTenantLoadPortalsComplete: {
            newState = {
                ...(state || defaultState),
            };
            if (!!action.tenantsResult) {
                newState.availableTenants = action.tenantsResult;
            }
            break;
        }
    }
    return newState ? newState : state ? state : defaultState;
}
